import { render, staticRenderFns } from "./DashboardCRM.vue?vue&type=template&id=cfce20a6&scoped=true"
import script from "./DashboardCRM.vue?vue&type=script&lang=js"
export * from "./DashboardCRM.vue?vue&type=script&lang=js"
import style0 from "./DashboardCRM.vue?vue&type=style&index=0&id=cfce20a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfce20a6",
  null
  
)

export default component.exports